import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {createTheme, ThemeProvider} from "@mui/material";
import {BrowserRouter, MemoryRouter} from "react-router-dom";
import {UserProvider} from "./UserContext";
import {blueGrey} from "@mui/material/colors";
import DateAdapter from '@mui/lab/AdapterMoment';
import {LocalizationProvider} from "@mui/lab";
import {koKR} from "@mui/material/locale";
import {ko} from "moment/locale/ko"
import {WarehouseProvider} from "./WarehouseContext";

const theme = createTheme({
  palette: {
    primary : {main : blueGrey[900]},
    secondary : {main : blueGrey[500]},
    // background : {
    //   default : blueGrey[100]
    // }
  }
  // status: {
  //   danger: orange[500],
  // },
}, koKR);

ReactDOM.render(
  <React.StrictMode>
    <LocalizationProvider locale={ko} dateAdapter={DateAdapter}>
      <BrowserRouter>
        <WarehouseProvider>
          <UserProvider>
            <ThemeProvider theme={theme}>
              <App />
            </ThemeProvider>
          </UserProvider>
        </WarehouseProvider>
      </BrowserRouter>
    </LocalizationProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
